import { computed as c, watch as d } from "vue";
import { useStore as n } from "./index552.js";
import { overflows as o } from "./index553.js";
function w(t, l, r) {
  let f = n(o), i = c(() => {
    let e = t.value ? f.value.get(t.value) : void 0;
    return e ? e.count > 0 : !1;
  });
  return d([t, l], ([e, m], [u], s) => {
    if (!e || !m) return;
    o.dispatch("PUSH", e, r);
    let a = !1;
    s(() => {
      a || (o.dispatch("POP", u ?? e, r), a = !0);
    });
  }, { immediate: !0 }), i;
}
export {
  w as useDocumentOverflowLockedEffect
};
